import { getName } from 'i18n-iso-countries';

import { getBrowserLocale } from '@/services/i18n';

export const getCountryName = (countryCode: string | null) =>
  countryCode ? getName(countryCode, getBrowserLocale()) : undefined;
